<template>
  <div :id="pageId">
    <div class="allPage" :class="explain ? 'd_flex' : 'd_flex'">
      <div v-if="(explain === 0 || explain === undefined || explain === null)">
        <div style="display: inline-block;vertical-align: middle">第{{(newsize * newPage) - (newsize - 1)}}至第{{returnNewCount}}条记录，共{{totalCount}}条数据</div>
        <div style="display: inline-block;vertical-align: middle;margin-left: 20px" v-if="needPageSize">
          <span style="display: inline-block;vertical-align: middle">每页</span>
          <select @change="changeSize" style="display: inline-block;vertical-align: middle;width: 80px!important;margin: 0 10px" class="allSelect" v-model="newpageSize" name="" id="">
            <option :value="10">10</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
            <option :value="500">500</option>
            <option :value="1000">1000</option>
          </select>
          <span style="display: inline-block;vertical-align: middle">条</span>
        </div>
      </div>
      <div v-if="explain === 1">显示第1到第10条记录，总共4条记录</div>
      <div v-if="explain === 2" class="colorZh">*规则集之间是“或者”的关系</div>
      <div>
        <span @click="fistPage()" class="botton"><i class="icon iconfont icondouble-arrow-left" style="display: inline-block;font-weight: 100;transform: scale(0.8);"></i></span>
        <span @click="prevPage()" class="botton"><i class="icon iconfont iconhoutui" style="display: inline-block"></i></span>
        <span @click="thisPage(list)" :key="index" v-for="(list,index) in pageList" :class="list === newPage ? 'num active': 'num'">{{list}}</span>
        <!--<span class="little">···</span>-->
        <span @click="nextPage()" class="botton"><i class="icon iconfont iconqianjin" style="display: inline-block"></i></span>
        <span @click="lastPage()" class="botton"><i class="icon iconfont icondouble-arrow-left1" style="display: inline-block;font-weight: 100;transform: scale(0.8);"></i></span>
        <span style="margin-left: 10px">跳转</span>
        <input v-model="goPage" type="text">
        <span>页</span>
        <span  @click="goToPage()"  class="go">GO</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page',
  props: [
    'totalPage',
    'totalCount',
    'page',
    'needPageSize',
    'pageSize',
    'explain',
    'size',
    'typeInId'
  ],
  data () {
    return {
      newpageSize: parseInt(this.pageSize) || 10,
      newotalPage: this.totalPage,
      newPage: this.page,
      newsize: this.size || this.newpageSize || this.$commonJs.commonPageSize,
      pageList: [],
      goPage: '1',
      pageId: this.typeInId || 'pageId' + new Date().getTime() + Math.random() * 1000,
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    console.log(this.needPageSize)
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    this.getPageList()
    this.newpageSize = parseInt(this.pageSize) || 10
  },
  computed: {
    returnNewCount () {
      console.log(this.newPage)
      console.log(this.newotalPage)
      if (this.newPage === this.newotalPage) {
        // console.log(1111111)
        return ((this.newotalPage - 1) * this.newsize) + (this.totalCount % this.newsize === 0 ? this.newsize : this.totalCount % this.newsize)
      } else {
        console.log(2222)
        console.log(this.newsize)
        console.log(this.newPage)
        return (((this.newsize * this.newPage) - (this.newsize)) + this.newsize)
      }
    }
  },
  methods: { // 所有的方法封装
    changeSize () {
      this.newsize = this.newpageSize
      this.$emit('on-changeSize', this.newpageSize)
    },
    getPageList () {
      this.pageList = []
      if (this.newotalPage <= 10) {
        for (let i = 1; i <= this.newotalPage; i++) {
          this.pageList.push(i)
        }
      } else {
        if (this.newotalPage - this.newPage <= 10) {
          for (let i = this.newotalPage - 10; i <= this.newotalPage; i++) {
            this.pageList.push(i)
          }
        } else {
          if (this.newPage > 5) {
            for (let i = this.newPage - 4; i <= this.newPage + 5; i++) {
              this.pageList.push(i)
            }
          } else {
            for (let i = 1; i <= 9; i++) {
              this.pageList.push(i)
            }
          }
        }
      }
    },
    fistPage () {
      this.getPageList()
      this.$emit('on-getList', 1)
    },
    lastPage () {
      this.getPageList()
      this.$emit('on-getList', this.newotalPage)
    },
    prevPage () {
      // console.log(this.page)
      if (this.newPage > 1) {
        // console.log(this.newPage)
        this.newPage--
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      }
    },
    nextPage () {
      if (this.newPage < this.newotalPage) {
        // console.log(this.newPage)
        this.newPage++
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      }
    },
    thisPage (page) {
      this.newPage = page
      this.getPageList()
      this.$emit('on-getList', this.newPage)
    },
    goToPage () {
      const num = /[0-9]/
      if (num.test(this.goPage) && this.goPage !== '0' && parseInt(this.goPage, 0) <= this.newotalPage) {
        this.newPage = parseInt(this.goPage, 0)
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '页码不正确',
          content: '请输入正确的页数',
          stayTime: 2
        })
      }
    }
  },
  components: {
  },
  watch: {
    totalPage (value) {
      console.log(value)
      this.newotalPage = value
      this.getPageList()
    },
    page (value) {
      console.log(value)
      this.newPage = value
      this.getPageList()
    },
    newpageSize(val){
      console.log('newpageSize')
      console.log(this.newpageSize)
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myComponents/page.vue